import { TucarTheme } from '@tucar/pit-stop';
import acGbtIcon from '../../../../public/images/plugs/AC-GBT.png';
import acType1Icon from '../../../../public/images/plugs/AC-Type1.png';
import acType2Icon from '../../../../public/images/plugs/AC-Type2.png';
import dcChademoIcon from '../../../../public/images/plugs/DC-CHAdeMO.png';
import dcGbtIcon from '../../../../public/images/plugs/DC-GBT.png';
import dcCcs1Icon from '../../../../public/images/plugs/DC-CCS1.png';
import dcCcs2Icon from '../../../../public/images/plugs/DC-CCS2.png';

export const plugIcons = {
  'AC-GB/T': acGbtIcon,
  Type1: acType1Icon,
  Type2: acType2Icon,
  CHAdeMO: dcChademoIcon,
  'DC-GB/T': dcGbtIcon,
  CCS1: dcCcs1Icon,
  CCS2: dcCcs2Icon,
};

export const getChipColorSessionStatus = (status) => {
  switch (status) {
    case 'Completed':
      return [TucarTheme.colors.blue400, TucarTheme.colors.blue100];
    case 'Active':
      return [TucarTheme.colors.green500, TucarTheme.colors.green100];
    default:
      return ['gray', '#E6E6E6'];
  }
};

export const getChipColorAndIconOcppStatus = (status) => {
  switch (status) {
    case 'Available':
      return [TucarTheme.colors.green500, TucarTheme.colors.green100, 'checkCircleRounded'];
    case 'Charging':
      return [TucarTheme.colors.blue400, TucarTheme.colors.blue100, 'loaderOutlined'];
    case 'Preparing':
      return [TucarTheme.colors.warning700, TucarTheme.colors.warning100, 'dotSpecial'];
    default:
      return ['gray', '#E6E6E6', 'cancelOutlined'];
  }
};

export const getPlugIcon = (plugType, currentType) => {
  let newPlug = `${plugType}`;
  if (newPlug === 'GB/T') {
    newPlug = `${currentType}-GB/T`;
  }
  return newPlug;
};

const translateCurrentTypeObj = {
  AC: 'Corriente Alterna',
  DC: 'Corriente Continua',
};

const translateCurrentTypeToVelocityObj = {
  AC: 'Carga lenta',
  DC: 'Carga rápida',
};

const translatePlugTypeObj = {
  Unknown: 'Desconocido',
};

const translateStatusObj = {
  Available: 'Disponible',
  Preparing: 'Preparando',
  Charging: 'Cargando',
  SuspendedEVSE: 'Suspendido por el cargador',
  SuspendedEV: 'Suspendido por el vehículo',
  Finishing: 'Finalizando',
  Reserved: 'Reservado',
  Faulted: 'Averiado',
  Unavailable: 'No disponible',
};

const translateSessionStatusObj = {
  Active: 'Activa',
  Completed: 'Completada',
  Invalid: 'Inválida',
  Pending: 'Pendiente',
  Reservation: 'Reservada',
  Unknown: 'Desconocida',
};

export const translateCurrentTypeToVelocity = (currentType) => {
  return translateCurrentTypeToVelocityObj[currentType] || 'Desconocido';
};

export const translateCurrentType = (currentType) => {
  return currentType.map((item) => translateCurrentTypeObj[item] || 'Desconocido');
};

export const translatePlugType = (plugType) => {
  return plugType.map((item) => translatePlugTypeObj[item] || item);
};

export const translateStatus = (status) => {
  return status.map((item) => translateStatusObj[item] || 'Desconocido');
};

export const translateOneStatus = (status) => {
  return translateStatusObj[status] || 'Desconocido';
};

export const translateSessionStatus = (status) => {
  return translateSessionStatusObj[status] || 'Desconocida';
};
